import React, { useRef } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { Color, Radius, Spacing } from "@glossy";
import { useSize } from "@lkf/hooks";

const TooltipRoot = styled.div<{ top: number; left: number }>`
  position: absolute;
  left: ${(props) => props.left}px;
  top: ${(props) => props.top}px;
  border-radius: ${Radius.Medium};
  padding: ${Spacing.MediumLarge};
  max-width: 300px;
  pointer-events: none;
  color: ${Color.White};
  background: ${Color.BlackPearl};
  transform: translate(-50%, 0);
  transition: all 0.1s ease;
  z-index: 1000;
`;

const Tooltip = styled(TooltipRoot)<{ caretPosition: string }>`
  &:after {
    position: absolute;
    content: "";
    display: block;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    top: calc(50% - 5px);
    border-right: ${(props) =>
      props.caretPosition === "right" && `5px solid ${Color.BlackPearl}`};
    right: ${(props) => props.caretPosition === "right" && "100%"};
    border-left: ${(props) =>
      props.caretPosition === "left" && `5px solid ${Color.BlackPearl}`};
    left: ${(props) => props.caretPosition === "left" && "100%"};
  }
`;

const Component = ({
  tooltipContent,
  left,
  top,
  tooltipPosition,
  caretPadding,
}) => {
  const tooltipContentRef = useRef();
  const { width, height } = useSize(tooltipContentRef);
  const leftPosition =
    tooltipPosition === "left"
      ? left - caretPadding - width / 2
      : left + caretPadding + width / 2;
  const topPosition = top - height / 2;
  return (
    <Tooltip
      left={leftPosition}
      top={topPosition}
      caretPosition={tooltipPosition}
      ref={tooltipContentRef}
    >
      {tooltipContent}
    </Tooltip>
  );
};

export const closeCustomTooltip = () => {
  const tooltipEl = document.getElementById("chartjs-tooltip");
  if (tooltipEl) {
    ReactDOM.unmountComponentAtNode(tooltipEl);
    tooltipEl.remove();
  }
};

export const openCustomTooltip = (tooltipModel, chart, tooltipContent) => {
  let tooltipEl = document.getElementById("chartjs-tooltip");
  if (!tooltipEl) {
    tooltipEl = document.createElement("div");
    tooltipEl.id = "chartjs-tooltip";
    document.body.appendChild(tooltipEl);
  }

  const position = chart.canvas.getBoundingClientRect();
  const { caretX, caretY, xAlign } = tooltipModel;
  const left = position.left + window.pageXOffset + caretX;
  const top = position.top + window.pageYOffset + caretY - 16;

  const tooltipPosition = xAlign === "right" ? "left" : "right";

  ReactDOM.render(
    <Component
      tooltipContent={<div>{tooltipContent}</div>}
      tooltipPosition={tooltipPosition}
      left={left}
      top={top}
      caretPadding={tooltipModel.options.caretPadding}
    />,
    tooltipEl
  );
};
